/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

// The editor creator to use.
import ClassicEditorBase from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';
import InlineEditorBase from '@ckeditor/ckeditor5-editor-inline/src/inlineeditor';

import Essentials from '@ckeditor/ckeditor5-essentials/src/essentials';
import Autoformat from '@ckeditor/ckeditor5-autoformat/src/autoformat';
import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment';
import Bold from '@ckeditor/ckeditor5-basic-styles/src/bold';
import Italic from '@ckeditor/ckeditor5-basic-styles/src/italic';
import Underline from '@ckeditor/ckeditor5-basic-styles/src/underline';
import Strikethrough from '@ckeditor/ckeditor5-basic-styles/src/strikethrough';
import Code from '@ckeditor/ckeditor5-basic-styles/src/code';
import Font from '@ckeditor/ckeditor5-font/src/font';
import BlockQuote from '@ckeditor/ckeditor5-block-quote/src/blockquote';
import CKFinder from '@ckeditor/ckeditor5-ckfinder/src/ckfinder';
import Heading from '@ckeditor/ckeditor5-heading/src/heading';
import Image from '@ckeditor/ckeditor5-image/src/image';
import ImageCaption from '@ckeditor/ckeditor5-image/src/imagecaption';
import ImageStyle from '@ckeditor/ckeditor5-image/src/imagestyle';
import ImageToolbar from '@ckeditor/ckeditor5-image/src/imagetoolbar';
import ImageUpload from '@ckeditor/ckeditor5-image/src/imageupload';
import Link from '@ckeditor/ckeditor5-link/src/link';
import List from '@ckeditor/ckeditor5-list/src/list';
import MediaEmbed from '@ckeditor/ckeditor5-media-embed/src/mediaembed';
import Paragraph from '@ckeditor/ckeditor5-paragraph/src/paragraph';
import PasteFromOffice from '@ckeditor/ckeditor5-paste-from-office/src/pastefromoffice';
import Table from '@ckeditor/ckeditor5-table/src/table';
import TableToolbar from '@ckeditor/ckeditor5-table/src/tabletoolbar';
import RedcoreUploadAdapter from './redcore.uploadadapter.js';

class ClassicEditor extends ClassicEditorBase {
}

class InlineEditor extends InlineEditorBase {
}

let plugins = [
    Essentials,
    Autoformat,
    Alignment,
    Bold,
    Italic,
    Underline,
    Strikethrough,
    Code,
    BlockQuote,
    CKFinder,
    Heading,
    Font,
    Image,
    ImageCaption,
    ImageStyle,
    ImageToolbar,
    ImageUpload,
    Link,
    List,
    MediaEmbed,
    Paragraph,
    PasteFromOffice,
    Table,
    TableToolbar,
    RedcoreUploadAdapter
];
// Plugins to include in the build.
ClassicEditor.builtinPlugins = plugins;
InlineEditor.builtinPlugins = plugins;

let config = {
    toolbar: {
        items:
            [
                'heading',
                'fontsize',
                'fontfamily',
                'fontcolor',
                'fontbackgroundcolor',
                'bold',
                'italic',
                'underline',
                'strikethrough',
                'highlightstack',
                'alignment',
                'numberedList',
                'bulletedList',
                'link',
                'code',
                'blockQuote',
                'imageUpload',
                'insertTable',
                'mediaEmbed',
                'undo',
                'redo',
                'tableColumn',
                'tableRow',
                'mergeTableCells',
                'imageStyle:full',
                'imageStyle:side'
            ]
    },
    image: {
        toolbar: [
            'imageStyle:full',
            'imageStyle:side',
            'imageTextAlternative'
        ]
    },
    mediaEmbed: {
        previewsInData: true
    },
    table: {
        contentToolbar: [
            'tableColumn',
            'tableRow',
            'mergeTableCells'
        ]
    },
    language: 'en'
};

// Editor configuration.
ClassicEditor.defaultConfig = config;
InlineEditor.defaultConfig = config;
export default {
    ClassicEditor, InlineEditor
}